import { ca } from '@cian/analytics';

import { NEWBUILDING_PROMO_BUILDER_OFFERS_CAROUSEL_OPTIONS } from '../../constants/newbuildingPromoBuilderOffers';
import { IJsonQuery } from '../../repositories/common/json_query';
import { INewbuildingPromoBuilderOffer } from '../../types/newbuildingPromoBuilderOffers';
import { getNewbuildingOffersPositions } from '../../utils/newbuildingPromoBuilderOffers';

export const trackBuilderLogoClick = ({
  jsonQuery,
  realtyUserId,
  source,
  builderCardUrl,
  title,
}: {
  jsonQuery: IJsonQuery;
  realtyUserId: number;
  source: string | undefined;
  builderCardUrl: string;
  title: string;
}) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'click',
    label: 'specproject_carousel_to_card_builder',
    page: {
      extra: {
        is_specproject: true,
        source,
        hit_url: builderCardUrl,
        carousel_name: title,
        carousel_place: 'below_listing',
      },
    },
    sc: jsonQuery,
    products: [
      {
        id: realtyUserId,
        offerType: 'userid',
      },
    ],
  });
};

export const trackBuilderButtonClick = ({
  jsonQuery,
  realtyUserId,
  source,
  builderAllOffersUrl,
  title,
}: {
  jsonQuery: IJsonQuery;
  realtyUserId: number;
  source: string | undefined;
  builderAllOffersUrl: string;
  title: string;
}) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'click',
    label: 'specproject_carousel_to_listing',
    page: {
      extra: {
        is_specproject: true,
        source,
        hit_url: builderAllOffersUrl,
        carousel_name: title,
        carousel_place: 'below_listing',
      },
    },
    sc: jsonQuery,
    products: [
      {
        id: realtyUserId,
        offerType: 'userid',
      },
    ],
  });
};

export const trackNewbuildingClick = ({
  jsonQuery,
  realtyUserId,
  position,
  newbuildingId,
  source,
  title,
  newbuildingUrl,
}: {
  jsonQuery: IJsonQuery;
  realtyUserId: number;
  position: number;
  newbuildingId?: number | null;
  source: string | undefined;
  title: string;
  newbuildingUrl: string | undefined;
}) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'click',
    label: 'specproject_carousel_to_cardjk',
    page: {
      extra: {
        is_specproject: true,
        to_object: newbuildingId,
        object_type: 'JK',
        position: position + 1,
        source,
        hit_url: newbuildingUrl,
        carousel_name: title,
        carousel_place: 'below_listing',
      },
    },
    sc: jsonQuery,
    products: [
      {
        id: realtyUserId,
        offerType: 'userid',
      },
    ],
  });
};

export const trackOfferClick = ({
  jsonQuery,
  realtyUserId,
  position,
  offerId,
  source,
  cardUrl,
  title,
}: {
  jsonQuery: IJsonQuery;
  realtyUserId: number;
  position: number;
  offerId: number;
  source?: string;
  cardUrl: string;
  title: string;
}) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'click',
    label: 'specproject_carousel_to_card',
    page: {
      extra: {
        is_specproject: true,
        to_object: offerId,
        object_type: 'offer',
        position: position + 1,
        source,
        hit_url: cardUrl,
        carousel_name: title,
        carousel_place: 'below_listing',
      },
    },
    sc: jsonQuery,
    products: [
      {
        id: realtyUserId,
        offerType: 'userid',
      },
    ],
  });
};

export const trackPromoBuilderOffersShow = ({
  jsonQuery,
  realtyUserId,
  offers,
  source,
  title,
  builderCardUrl,
}: {
  jsonQuery: IJsonQuery;
  realtyUserId: number;
  source?: string;
  offers: INewbuildingPromoBuilderOffer[];
  title: string;
  builderCardUrl: string;
}) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'show_sopr',
    label: 'specproject_carousel',
    page: {
      extra: {
        is_specproject: true,
        content: getNewbuildingOffersPositions({
          step: NEWBUILDING_PROMO_BUILDER_OFFERS_CAROUSEL_OPTIONS.slidesPerView,
          activeSlideIndex: 0,
          offers,
        }),
        source,
        hit_url: builderCardUrl,
        carousel_name: title,
        carousel_place: 'below_listing',
      },
    },
    sc: jsonQuery,
    products: [
      {
        id: realtyUserId,
        offerType: 'userid',
      },
    ],
  });
};

export const trackSlideChange = ({
  jsonQuery,
  realtyUserId,
  offers,
  activeSlideIndex,
  source,
  title,
  builderCardUrl,
}: {
  jsonQuery: IJsonQuery;
  realtyUserId: number;
  activeSlideIndex: number;
  offers: INewbuildingPromoBuilderOffer[];
  source: string | undefined;
  title: string;
  builderCardUrl: string;
}) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'click',
    label: 'specproject_carousel_scroll',
    page: {
      extra: {
        is_specproject: true,
        content: getNewbuildingOffersPositions({
          step: NEWBUILDING_PROMO_BUILDER_OFFERS_CAROUSEL_OPTIONS.slidesPerView,
          activeSlideIndex,
          offers,
        }),
        source,
        hit_url: builderCardUrl,
        carousel_name: title,
        carousel_place: 'below_listing',
      },
    },
    sc: jsonQuery,
    products: [
      {
        id: realtyUserId,
        offerType: 'userid',
      },
    ],
  });
};
